import { sectionTone, type SectionTone } from '../shared/section-heading'

// The dev playground's pages and in-page sections: a leaf, so the layout's pending UI (on the eager path) and its
// tree share them without the tree's weight. Untranslated, like the rest of the playground: internal copy no customer
// sees.

export const DEV_PAGES = [
  { key: 'emails', to: '/dev-resources/emails', label: 'Email templates' },
  { key: 'errors', to: '/dev-resources/errors', label: 'Captured errors' },
  { key: 'components', to: '/dev-resources/components', label: 'Components' },
  { key: 'transitions', to: '/dev-resources/transitions', label: 'Transitions' },
] as const
export type DevPageKey = (typeof DEV_PAGES)[number]['key']

/** The pages that take the whole width beside the tree (their routes' `staticData.fullWidth`): a table, a playground. */
export const DEV_WIDE_PAGES: readonly DevPageKey[] = ['errors', 'transitions']

/** The page a pathname opens; the bare `/dev-resources` redirects to the first. */
export function devPageOf(pathname: string): DevPageKey {
  return DEV_PAGES.find((page) => pathname.includes(page.to))?.key ?? 'emails'
}

/** The component demos' sections, in page order: their anchors, the cards' headings (component-demos.tsx) and the tree's labels. */
export const COMPONENT_DEMOS = [
  { id: 'demo-avatars', label: 'Avatars', description: 'All avatar sizes without image.' },
  { id: 'demo-toasts', label: 'Toasts', description: 'All toast variants with pill icons.' },
  {
    id: 'demo-fetching',
    label: 'Fetching progress',
    description: 'A slim progress bar that animates toward 95%, then completes and reverses out when fetching ends.',
  },
] as const

/** An email template's anchor on the gallery. */
export const emailAnchor = (id: string) => `email-${id}`

/** The playground's one hue, as the account's pages share amber: every card here carries it. */
export const DEV_TONE: SectionTone = sectionTone('violet')
